import { PricingPlanContent } from '@anm/api/modules/pricing';
import { SubscriptionDetails, SubscriptionPeriod } from '@anm/api/modules/subscription';
import { UserSubscriptionDetails } from '@anm/api/modules/user';
import { PricingTablePlan } from '@anm/components/pricing/PricingTable';
import { ANNUAL } from '@anm/constants/subscription';
import isHigherPlan from '@anm/helpers/subscription/isHigherPlan';
import isSameSubscription from '@anm/helpers/subscription/isSameSubscription';
import { UserTeamPermission } from 'types/user';

import isSamePeriod from './isSamePeriod';
import mapFeature from './mapFeature';

type CalcPlanContent = {
  view: SubscriptionPeriod;
  planContent: PricingPlanContent;
  subscription: SubscriptionDetails;
  teamPermissions?: UserTeamPermission;
  discount?: number;
  currentSubscription?: UserSubscriptionDetails;
};

export default ({
  view,
  discount,
  planContent,
  subscription,
  currentSubscription
}: CalcPlanContent): PricingTablePlan => {
  const features = planContent.features.map(({ title, features }) => ({
    title,
    features: features.map(planFeature => mapFeature(planFeature, subscription.features))
  }));
  const isAnnual = view === ANNUAL;
  const periodName = isAnnual ? 'annual' : 'monthly';
  const price = isAnnual ? subscription.annualPrice : subscription.monthlyPrice;
  const isUserGuest = !currentSubscription;
  const isUserFree = currentSubscription?.name === 'WaveFree';
  const isFreePlanContent = planContent.id === 'WaveFree';
  const isSamePlan = isSameSubscription(planContent.id, currentSubscription?.name);
  const planName = planContent.planName || subscription.displayName;
  const isPlanHigherThanCurrent = currentSubscription && isHigherPlan(currentSubscription.name, subscription.name);

  return {
    price,
    discount,
    features,
    isAnnual,
    periodName,
    isSamePlan,
    sibling: planContent.sibling,
    id: planContent.id,
    variant: planContent.variant,
    planName,
    isSamePeriod: isUserFree || isSamePeriod({ view, currentSubscription }),
    description: planContent.description,
    showPlanTopButton: isUserFree || isUserGuest,
    showPlanBottomButton:
      (!isFreePlanContent && (isSamePlan || isPlanHigherThanCurrent)) ||
      isUserGuest ||
      (isFreePlanContent && isUserFree)
  };
};
